/**
 * Javascript pro veřejnou část stránek.
 *
 * @package    www-elisha/jukeboxhotel.com
 * @subpackage .
 * @author     Reklalink <info@reklalink.cz>
 * @copyright  2024 Reklalink s.r.o.
 */

$(document).ready(
	function () {
		homepage_slider();
		google_map();

		my_validate();
	}
);

function homepage_slider()
{
	if ($('#homepage-carousel').length) {
		const swiper = new Swiper(
			'#homepage-carousel',
			{
				loop: true,
				slidesPerView: 1,
				preventClicksPropagation: false,
				grabCursor: true,
				shortSwipes: false,
				longSwipesMs: 50,
				longSwipesRatio: 0.1,
				navigation: {
					nextEl: ".swiper-button-next",
					prevEl: ".swiper-button-prev"
				},
				pagination: {
					el: ".swiper-pagination",
					clickable: true
				}
			}
		);
	}//end if
}

function google_map() {
	if($('#map').length
		&& cookie_consent_check_analytics() == true
	) {
		var div = $('#map');
		var src = div.attr('data-src');

		if (src.length > 20) {
			var iframe = document.createElement('iframe');
			iframe.setAttribute('src', src);
			div.empty();
			div.append(iframe);
		}

	}
}

function my_validate() {
	var ajax_form_before_lang_arr = {
		cs: 'Formulář se odesílá, prosím počkejte.',
		en: 'The form is being submitted, please wait.',
		ru: 'Форма отправляется, пожалуйста, подождите.',
		de: 'Das Formular wird gesendet, bitte warten.'
	};

	var ajax_form_error_lang_arr = {
		cs: 'Bohužel formulář nelze odeslat, prosím kontaktujte nás jinou cestou. Děkujeme za pochopení.',
		en: 'Unfortunately the form cannot be sent, please contact us in another way Thank you for your understanding.',
		ru: 'К сожалению, форма не может быть отправлена, пожалуйста, свяжитесь с нами другим способом.\
				Спасибо за ваше понимание.',
		de: 'Leider kann das Formular nicht gesendet werden. Bitte kontaktieren Sie uns auf andere Weise.\
				Vielen Dank für Ihr Verständnis.'
	};

	var form = $('.validate');
	form.each(
		function () {
			var self = $(this);
			$(this).validate(
				{
					ignore: [],
					lang: $('html').attr('lang'),
					highlight: function (element) {
						$(element).closest('div').addClass('has-error');
					},
					unhighlight: function (element) {
						if ($(element).hasClass('error-as-tooltip')) {
							$(element).tooltip('dispose')
						} else {
							$(element).closest('div').removeClass('has-error');
						}
					},
					errorElement: 'span',
					errorClass: 'form-text',
					errorPlacement: function (error, element) {
						if (element.hasClass('error-as-tooltip')) {
							var last_error = $(element).attr('data-title');
							if (last_error !== error.text()) {
								$(element).tooltip('dispose')
									.attr('data-title', error.text())
									.data('title', error.text())
									.tooltip(
										{
											trigger: 'manual',
											template: '<div class="tooltip has-error" role="tooltip"><div class="arrow"></div><div class="tooltip-inner"></div></div>'
										}
									)
									.tooltip('show');
							}
						} else if (element.parent('.input-group').length) {
							$('<div>', {class: 'has-error'}).append(error).insertAfter(element.parent());
						} else if (element.hasClass('select2')) {
							error.insertAfter(element.parent());
						} else if (element.parent('.custom-checkbox').length) {
							error.insertAfter(element.parent('.custom-checkbox').find('.custom-control-label'));
						} else if (element.parent('.custom-file').length) {
							error.insertAfter(element.parent('.custom-file').find('.custom-file-label'));
						} else {
							error.insertAfter(element);
						}//end if
					},
					submitHandler: function (form) {
						var ajax = $(form).attr('data-ajax');

						if (typeof ajax !== typeof undefined && ajax !== false) {
							var form_response = $(form).find('.response');
							var form_data     = new FormData();

							// Projdem všechna data formuláře.
							var self_zero_length = self[0].length;
							for (i = 0; i < self_zero_length; i++) {
								var item  = self[0][i];
								var $item = $(item);
								if ($item.attr('type') === 'hidden' || $item.attr('type') === 'button' || $item.attr('type') === 'submit') {
									continue
								} else if ($item.attr('type') === 'file') {
									// Vložíme obrázky.
									var files_length = item.files.length;
									for (j = 0; j < files_length; j++) {
										form_data.append($item.attr('name'), item.files[j]);
									}
								} else if ($item.attr('type') === 'checkbox') {
									// Emulace chování PHP.
									if ($item.is(':checked') === true) {
										form_data.append($item.attr('name'), 'on');
									}
								} else {
									form_data.append($item.attr('name'), $item.val());
								}
							}//end for

							$.ajax(
								{
									url: '?ajax=' + ajax,
									type: 'POST',
									data: form_data,
									processData: false,
									contentType: false,
									beforeSend: function () {
										$(form).find('button[type="submit"]').attr('disabled','disabled');
										form_response.empty();
										form_response.append('<div class="alert alert-info" role="alert"><i class="fa fa-refresh fa-spin fa-3x fa-fw"></i> ' + ajax_form_before_lang_arr[$('html').attr('lang')] + '</div>');
									},
									success: function (response) {
										form_response.empty();
										form_response.append(response);
									},
									error: function () {
										form_response.empty();
										form_response.append('<div class="alert alert-danger" role="alert"><i class="fa fa-ban fa-3x fa-fw"></i> ' + ajax_form_error_lang_arr[$('html').attr('lang')] + '</div>');
									}
								}
							);
							return false;
						} else {
							return true;
						}//end if
					}
				}
			);
		}
	);
}

function hcaptcha_onload()
{
	$(document).ready(
		function () {
			$('[name="h-captcha-response"]').attr('data-rule-required', 'true');
			my_validate();
		}
	);
}

function hcaptcha_callback(e)
{
	$('[name="h-captcha-response"]').each(
		function () {
			if ($(this).val() === e) {
				$(this).valid();
			}
		}
	);
}
